<template>
  <li class="app-overview-item">
    <span class="app-overview-item__label">
      <app-text-help :text="label" :tip="tip"></app-text-help>
    </span>
    <span class="app-overview-item__value">{{ value }}</span>
  </li>
</template>

<script>
import AppTextHelp from '@/components/AppTextHelp'

export default {
  name: 'AppOverviewBarItem',
  props: {
    label: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    },
    value: {
      type: [ String, Number ],
      default: ''
    }
  },
  components: {
    AppTextHelp
  }
}
</script>

<style lang="scss">
.app-overview-item {
  flex: 1;
  margin-right: 24px;
  border-right: 1px solid #ccc;

  &:last-child {
    border-right: 0;
  }

  &__label,
  &__value {
    display: block;
  }

  &__label {
    margin-bottom: 10px;
    color: #666;
    font-size: 14px;
  }

  &__value {
    color: #333;
    font-size: 18px;
  }
}
</style>
